<template>
    <v-card>
        <v-toolbar dark color="primary">
            <v-btn 
                icon 
                dark 
                :disabled="submitLoading" 
                @click="cancel">
                <v-icon large>close</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title>
                <span v-if="editing">Edit Public Holiday</span>
                <span v-else>Add Public Holiday</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        
        <v-form ref="editForm" v-model="editValid">
            <v-layout class="dialog-content">
                <v-flex xs12 md6 offset-md3 mt-4>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-text-field 
                                box
                                clearable
                                label="Name"
                                v-model="editData.HolidayName" 
                                :rules="[
                                    rules.required, 
                                    rules.maxOneHundredCharacters
                                ]" 
                                counter >
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-menu v-model="editDate" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field :value="editData.Date | formatDate" label="Date" prepend-icon="event" readonly v-on="on" append-icon="close" :rules="[rules.required]" @click="editDate = true"></v-text-field>
                                </template>
                                <v-date-picker :value="editData.Date" :min="today" @input="updateDate(editData, $event)"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs12>
                            <v-autocomplete
                                label="Jurisdictions"
                                :items="options"
                                item-value="Region"
                                item-text="Region"
                                v-model="editData.Regions"
                                return-object
                                box 
                                chips 
                                multiple
                                clearable
                                placeholder="State/Region"
                                >
                            </v-autocomplete>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap class="dialog-action-buttons">
                        <v-flex xs12 sm6>
                            <v-btn 
                                block 
                                color="success" 
                                :disabled="!editValid" 
                                :loading="submitLoading" 
                                @click="submit">
                                <span>Save</span>
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-btn 
                                block 
                                color="error" 
                                :disabled="submitLoading" 
                                @click="cancel">
                                <span>Cancel</span>
                            </v-btn>
                        </v-flex>
                        <v-flex xs12>
                            <v-alert 
                                :value="submitError != null" 
                                outline 
                                type="error">
                                <span>{{ submitError }}</span>
                            </v-alert>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-form>
    </v-card> 
</template>

<script>
import validationRules from "@/helpers/validationrules";

export default {
    props: {
        item: {
            required: true,
            type: Object
        },
        options: {
            requited: true,
            type: Array
        },
        submitError: {
            required: false,
            type: String
        },
        submitLoading: {
            required: false,
            type: Boolean
        }
    },
    data() {
        return {
            rules: validationRules.rules,
            editData: {},
            editDate: false,
            editValid: false,
            index: 0,
            error: null   
        }
    },
    computed: {
        editing(){
            return this.editData.ID != null;
        },
        today() {
            var today = new Date().toISOString()
            return today.substring(0,10)
        }
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        updateDate(item, value) {
            this.$set(item, 'Date', value);
            this.editDate = false;
        },
        async submit(){
            if (this.editData.UserDefinedValue) {
                this.editData.Name = "User Defined";
            }
            
            this.$emit("submit", this.editData);
        },
    },
    async created() {
        this.editData = JSON.parse(JSON.stringify(this.item));
    }
}
</script>